import { makeStyles } from '@material-ui/core';

import { neutral } from 'shared/styles/colors';

export default makeStyles({
  article: {
    display: 'flex',
    gap: '0.5rem',
    flexDirection: 'column',
    borderBottom: `1px solid ${neutral[20]}`,
    '&[data-has-replacement="true"]': {
      padding: '0 1rem 1rem',
    },
  },

  productHeader: {
    color: neutral[100],
    display: 'flex',
    gap: '1rem',
    alignItems: 'center',
    justifyContent: 'space-between',
    '& > h2': {
      display: 'flex',
      gap: '0.5rem',
      alignItems: 'center',
    },
    '& > h2, > span': {
      fontWeight: 600,
      fontSize: '1rem',
      lineHeight: '1.5rem',
    },
    '& > h2 > span': {
      paddingRight: '0.25rem',
    },
  },
  productDescription: {
    fontWeight: 400,
    fontSize: '0.75rem',
    lineHeight: '1.25rem',
    color: neutral[60],
  },

  stockoutSection: {
    '& [aria-label="toppingDetail"] *': {
      color: neutral[50],
    },
    '&[data-has-replacement="true"]': {
      '& [aria-label="product-detail-wrapper"]': {
        padding: '0 0.75rem',
        backgroundColor: neutral['10'],
      },
      '& [aria-label="detailSubtotal"]': {
        visibility: 'hidden',
      },
    },
  },
});
